import { addDeviceTypeClass } from 'shared/javascripts/util/device_class'

up.compiler('body', (element) => {
  addDeviceTypeClass(element)
})
